import { ActionModeType, EntityOnboardMessageModel, EntityOnboardSectionModel, EntityPageType, EntityType } from "src/app/model";

export interface EntityOnboardStateModel {
  entityId?: string;
  formStatus: ActionModeType;
  data?: Record<string, unknown>;
}

export interface EntityOnboardModel {
  entityType: EntityType;
  pageType: EntityPageType;
  formField: EntityOnboardSectionModel[];
  formResponse: EntityOnboardMessageModel;
  bulkUploadEnable?: boolean;
  bulkUploadButtonLabel?: string;
  bulkUploadTitle?: string;
  bulkUploadSubtitle?: string;
  apiType ?: string;
  inventoryApiType ?: string;
  formStatus?: ActionModeType;
  modalType?: string;
  data?: any;
  path ?: string
}

export interface EntityOnboardPayloadModel extends EntityOnboardFormDataModel {
  siteId: string;
}

export interface EntityOnboardFormDataModel {
  [s: string]: any;
}

export interface EntityOnboardResponseModel {
  [s: string]: any;
  errors?: string[];
}

export interface EntityOnboardDataPayloadModel {
  entityId: string;
}

export interface EntityOnboardDataModel extends EntityOnboardFormDataModel {
  siteId?: string;
}